/**
 * Переключатель нового интерфейса. С 2026-10-01 новый интерфейс включён по
 * умолчанию; прежний выбирается на устройстве кнопкой «Открыть прежнюю
 * версию» или параметром ?ui=v1 в адресе PWA и запоминается как 'v1' в
 * localStorage. Старое значение 'v2' (включали вручную) тоже значит «новый».
 */
const KEY = 'procoach_ui'

function read(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

function write(value: string | null) {
  try {
    if (value) localStorage.setItem(KEY, value)
    else localStorage.removeItem(KEY)
  } catch {
    // Приватный режим и т.п.: переключатель просто не запомнится.
  }
}

/** Учесть ?ui=v2 / ?ui=v1 в адресе и сказать, включён ли новый интерфейс. */
export function isRedesignEnabled(): boolean {
  try {
    const param = new URLSearchParams(window.location.search).get('ui')
    if (param === 'v2') write(null)
    if (param === 'v1') write('v1')
  } catch {
    // нет window - остаётся выбор по умолчанию
  }
  return read() !== 'v1'
}

/** Включить или выключить новый интерфейс и перезапустить приложение. */
export function setRedesignEnabled(enabled: boolean) {
  write(enabled ? null : 'v1')
  // В мини-приложении параметры запуска с подписью лежат в адресе: без них
  // оно потеряет вход, поэтому только reload. В PWA - с корня, чтобы новый
  // интерфейс открылся на «Сегодня», а не на случайном старом пути.
  const w = window as unknown as { Telegram?: { WebApp?: { initData?: string } }; WebApp?: { initData?: string } }
  if (w.Telegram?.WebApp?.initData || w.WebApp?.initData) window.location.reload()
  else window.location.assign('/')
}
